import { render, staticRenderFns } from "./HighlightedNewsCard.vue?vue&type=template&id=3e54de40&scoped=true&"
import script from "./HighlightedNewsCard.vue?vue&type=script&lang=js&"
export * from "./HighlightedNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedNewsCard.vue?vue&type=style&index=0&id=3e54de40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54de40",
  null
  
)

export default component.exports